<ng-container *ngIf="!userService.isOnlyTg">
    <ng-container *ngIf="walletNftHoldings?.length">
        <div class="flex flex-col gap-y-5 w-full" [ngClass]="{'max-h-[600px] overflow-y-auto':pageType === 'profile'}">
            <app-collection-holdings *ngFor="let collection of walletNftHoldings" [collection]="collection"></app-collection-holdings>
        </div>
    </ng-container>

    <div *ngIf="!walletNftHoldings?.length" class="w-[120px] mx-auto text-center text-[#b5b5b5]">
        <img class="mx-auto w-36" src="/assets/imgs/no-data/no-data.png" alt="No Token Data" />
        <div>No Holdings</div>
    </div>
</ng-container>

<div *ngIf="userService.isOnlyTg">
    <!-- TG Connect Wallet -->
    <div class="text-center pb-10 text-[#b5b5b5]">
        <img class="mx-auto w-32" src="/assets/imgs/no-data/no-data.png" alt="No Data" />
        <div>Please connect your wallet first.</div>
        <button nz-button nzType="primary" class="mt-4 !h-[34px] !w-[137px]" nzSize="small" (click)="commonService.showLogInModal('Connect New Wallet')">
            <span class="colorful-text">Connect Wallet</span>
        </button>
    </div>
</div>
